import { FC } from 'react'
import { useSnackbar } from 'notistack'

import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { IconButton, lighten, styled, TextField } from '@mui/material'

import { dialogInputStopPropagation } from '../ConsoleDialog'

export const copyContentTestId = 'copy-content-test-id'
export const copyContentValueTestId = 'copy-content-value-test-id'
export const copyContentClickTestId = 'copy-content-click-test-id'

const CopyContentIcon = styled(ContentCopyIcon)(({ theme }) => ({
  color: lighten(theme.palette.primary.main, 0.01)
}))

type CopyContentProps = {
  label?: string
  value?: string
  displayValue?: string
  mono?: boolean
}

export const CopyContent: FC<CopyContentProps> = ({ label, value, mono, displayValue }) => {
  const { enqueueSnackbar } = useSnackbar()

  const onCopyClick = () => {
    navigator.clipboard.writeText(`${value}`).then(() => {
      enqueueSnackbar('Copied!', { variant: 'success' })
    })
  }

  return (
    <TextField
      {...dialogInputStopPropagation}
      data-testid={copyContentValueTestId}
      fullWidth
      variant="outlined"
      label={[label, '(read only)'].filter(Boolean).join(' ')}
      value={displayValue || value}
      InputProps={{
        endAdornment: (
          <IconButton onClick={onCopyClick}>
            <CopyContentIcon />
          </IconButton>
        ),
        readOnly: true,
        sx: {
          fontFamily: mono ? 'monospace' : undefined
        }
      }}
      InputLabelProps={{ shrink: true }}
      multiline
    />
  )
}
